<template><div><h1 id="erlosminderung-erfassen" tabindex="-1"><a class="header-anchor" href="#erlosminderung-erfassen"><span>Erlösminderung erfassen</span></a></h1>
<p>Erlösminderung manuell erfassen — Erlösminderung in manuellen Buchungen erfassen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden Erlösminderungen erfasst. Der eingetragene Betrag wird einer bestehenden Buchung wieder abgezogen. Bei einer Erlösminderung in Fremdwährung wird der Umrechnungskurs zum ursprünglichen Fakturadatum, und nicht der Kurs am Valutadatum der Erlösminderung, genommen. zu einer Erlösminderung kenn der MWST-Code eingetragen werden. Damit wird der MWST-Anteil der Erlösminderung aus dem entsprechnden MWST-Konto abgezogen.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Manuelle Buchungen → Erlösminderung (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personen-ID</dt>
<dd>Adresse zu der die Erlösminderung gebucht wird</dd>
<dt>Betrag</dt>
<dd>Betrag eintragen</dd>
<dt>Währung</dt>
<dd>Fremdwährung</dd>
<dt>Valutadatum</dt>
<dd>Valutadatum der Buchung</dd>
<dt>Mandant</dt>
<dd>Der <a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandant</a> wird nur eingetragen, wenn er auf Grund der Konteneingabe nicht eindeutig feststellbar ist</dd>
<dt>Konto</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.konti.html" title="Konti">Konto</a></dd>
<dt>Kostenstelle</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</a></dd>
<dt>Kostenträger</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></dd>
<dt>Zahlungsnummer</dt>
<dd>Frei definierbare Zahlungsnummer</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>siehe oben</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>siehe oben</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


